import { action, makeObservable, observable } from 'mobx';
import { getCurrentSuiteId } from '~/utils/brand';
import { SuiteId } from '@libs/shared';

export interface WxWorkLoginConfig {
    memberConfig?: Window['jdy_wechat_corp_config'];
    memberUrl?: string;
    adminUrl?: string;
}

/** 登录页共享的响应式状态。 */
export default class AccountModel {
    currentSuiteId: SuiteId = getCurrentSuiteId();

    hasSelectedSuite = false;

    wxWorkLoginConfig: WxWorkLoginConfig = {
        memberConfig: window.jdy_wechat_corp_config,
        memberUrl: window.jdy_wechat_corp_member_url,
        adminUrl: window.jdy_wechat_corp_admin_url
    };

    constructor() {
        makeObservable(this, {
            currentSuiteId: observable,
            hasSelectedSuite: observable,
            wxWorkLoginConfig: observable.ref,
            setWxWorkLoginSuite: action,
            resetSuiteSelection: action
        });
    }

    /** 切换企业微信登录 Suite，并同步兼容旧登录链路的全局 Suite。 */
    setWxWorkLoginSuite(suiteId: SuiteId, config: WxWorkLoginConfig) {
        this.currentSuiteId = suiteId;
        this.hasSelectedSuite = true;
        this.wxWorkLoginConfig = config;
    }

    /** 返回平台账户登录并清除本次 Suite 选择。 */
    resetSuiteSelection() {
        this.currentSuiteId = SuiteId.PLATFORM;
        this.hasSelectedSuite = false;
    }
}
